import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AwardStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path d="M12 12V18" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
			<path
				d="M15.9996 22H8C8 19.791 9.79087 18 11.9999 18C14.209 18 15.9998 19.7909 15.9996 22Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M5 2H19V5C19 8.86599 15.866 12 12 12C8.13401 12 5 8.86599 5 5V2Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 5H2C2 8 3 10 4.5 11"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 5H22C22 8 21 10 19.5 11"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

AwardStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AwardStrokeIcon;
